export default __webpack_public_path__ + "locales/lo-LA/DeleteThirdPartyDialog.json?hash=c67da1c5be490ab50e75b3c7eb76a0b4";